import { useQuery } from '@tanstack/react-query';
import secureLocalStorage from 'react-secure-storage';
import { serverRequest } from '../util/server_request';
import { extractErrorMessage } from './extractErrorMessage';
import { notifyUser } from '../util/util';

const notifiedErrors = new Set();

// Helper function to notify only once for the same error
const notifyOnce = (type, message, title = "") => {
  if (!notifiedErrors.has(message)) {
    notifiedErrors.add(message);
    notifyUser(type, message, title);
  }
};

export function useWithdrawalReasons() {
  return useQuery({
    queryKey: ['withdrawal-reasons'],
    queryFn: async () => {
      try {
        const result = await serverRequest('GET', 'policy/withdrawal-reasons');
        if (!result || !result.success) {
          throw new Error(result?.message || 'Failed to fetch withdrawal reasons');
        }
        return result;
      } catch (error) {
        const errorMessage = extractErrorMessage(error, 'Failed to fetch withdrawal reasons');
        notifyOnce("error", errorMessage, "Error");
        throw new Error(errorMessage);
      }
    },
    enabled: !!secureLocalStorage.getItem('token'),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
